import { MODULE_NAME_REGEX, TERRAFORM_PROVIDER_REGEX } from "./constants";

const MIN_MODULE_NAME_LENGTH = 2;

export const getDetailsFromRepo = (repo: string) => {
  const parts = repo.split("-", 3);

  if (parts.length < 3 || parts[0] !== "terraform") {
    return {
      name: repo,
      provider: "",
    };
  }

  const [, provider, ...nameParts] = repo.split("-");

  return {
    name: nameParts.join("-"),
    provider,
  };
};

export const validateNameField = (value?: string): string | true => {
  if (value === undefined || value.trim() === "") {
    return "Name field is required.";
  }

  const trimmed = value.trim();
  if (trimmed.length < MIN_MODULE_NAME_LENGTH) {
    return "Name must be at least 2 characters.";
  }

  if (!MODULE_NAME_REGEX.test(trimmed)) {
    return "Name must start with a lowercase letter, end with a lowercase letter or digit, and may only contain lowercase letters, digits, dashes and underscores.";
  }

  return true;
};

/**
 * Empty / whitespace-only is allowed (backend defaults to "default").
 * If set, must be non-empty after trim and match `^\w+$`.
 */
export const validateTerraformProviderField = (value?: string): string | true => {
  const trimmed = value?.trim() ?? "";
  if (trimmed === "") {
    return true;
  }

  if (!TERRAFORM_PROVIDER_REGEX.test(trimmed)) {
    return "Provider must only contain letters, digits, and underscores.";
  }

  return true;
};
